export const areaLabels = {
  master: 'Master',
  commercial: 'Comercial',
  marketing: 'Marketing',
  administrative: 'Administrativo',
  operations: 'Operações',
  compliance: 'Compliance',
};

export const jobTitleLabels = {
  director: 'Diretor',
  manager: 'Gerente',
  analyst: 'Analista',
  intern: 'Estagiário',
  trainer: 'Treinador',
  planner: 'Planejador',
};

export const statusLabels = {
  active: 'Ativo',
  inactive: 'Inativo',
};

export const companyTypeOptions = [
  { value: 'MEI', label: 'MEI' },
  { value: 'LIMITED', label: 'Sociedade limitada' },
  { value: 'INDIVIDUAL', label: 'Empresário individual' },
  { value: 'ASSOCIATION', label: 'Associação' },
];

export const transferIntervalOptions = [
  { value: 'daily', label: 'Diário' },
  { value: 'weekly', label: 'Semanal' },
  { value: 'monthly', label: 'Mensal' },
];

export const accountTypeOptions = [
  { value: 'conta_corrente', label: 'Corrente' },
  { value: 'conta_poupanca', label: 'Poupança' },
  { value: 'conta_corrente_conjunta', label: 'Corrente conjunta' },
  { value: 'conta_poupanca_conjunta', label: 'Poupança conjunta' },
];

const bankLabels = {
  '001': 'Banco do Brasil',
  '033': 'Santander',
  '077': 'Banco Inter',
  104: 'Caixa Econômica Federal',
  208: 'BTG Pactual',
  237: 'Bradesco',
  260: 'Nubank',
  336: 'C6 Bank',
  341: 'Itaú',
};

export const formatDocument = (value) => {
  const digits = String(value || '').replace(/\D/g, '');

  if (digits.length === 11) {
    return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }

  if (digits.length === 14) {
    return digits.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  }

  return value || '—';
};

export const formatPostalCode = (value) => {
  const digits = String(value || '').replace(/\D/g, '');
  if (digits.length !== 8) return value || '—';
  return digits.replace(/(\d{5})(\d{3})/, '$1-$2');
};

export const formatPhoneNumber = (value) => {
  const digits = String(value || '').replace(/\D/g, '');
  if (digits.length === 11) return digits.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  if (digits.length === 10) return digits.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
  return value || '—';
};

export const formatDate = (value, includeTime = false) => {
  if (!value) return '—';

  if (!includeTime && /^\d{4}-\d{2}-\d{2}/.test(value)) {
    const [year, month, day] = value.slice(0, 10).split('-');
    return `${day}/${month}/${year}`;
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  return new Intl.DateTimeFormat('pt-BR', includeTime ? { dateStyle: 'short', timeStyle: 'short' } : {}).format(date);
};

export const formatPercentage = (value) => {
  if (value === null || value === undefined || value === '') return '—';
  return `${Number(value).toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 2 })}%`;
};

export const formatBankCode = (value) => {
  if (!value) return '—';
  const code = String(value).padStart(3, '0');
  return bankLabels[code] ? `${code} (${bankLabels[code]})` : code;
};

export const optionLabel = (options, value) => options.find((option) => option.value === value)?.label || value || '—';

export const profileArea = (profile) => (profile?.adminMaster ? 'master' : profile?.area || '');
